import { createFileRoute } from "@tanstack/react-router";
import { OrgAppSettingPage } from "./-components/OrgAppSettingPage";

export const Route = createFileRoute("/_staff/apps/_list/settings/")({
  component: OrgAppSettingPage,
});
